export default __webpack_public_path__ + "static/media/Business-800X500.e49a8ab3.png";